import React,{useEffect} from "react";
import "./Header.scss";
import Freadom from "assets/image/cbse_reading.png";
import { Button } from "antd";


function Header() {
  const currentPath = window.location.pathname;
  useEffect(() => {
    document.title = "CBSE Reading App";
  }, []);
  return (
    <div className="header">
      <img src={Freadom} alt="logo" />
      {/* <h4 className="logo_name">CBSE Reading App</h4> */}
      
    </div>
  );
}

export default Header;
